import useTranslator from "../../hooks/useTranslator";
import { convertCurrencyFormat } from "../../helper/common";
import { Button, Card, Checkbox, Icon, TextField } from "../design";
import "./IncomeSourceCard.css";

const CustomIncomeSourceCard = ({
  userId,
  sourceKey,
  selectedSource = [],
  changeSelectedSource,
  title,
  amount,
  hasDuplicateTitle,
  onTitleChange,
  onAmountChange,
  onRemove,
}) => {
  const { _t } = useTranslator();
  const isActive = selectedSource?.includes(sourceKey);

  const monthlyAmount =
    Number(amount) > 0 ? convertCurrencyFormat(Number(amount)) : "0";

  return (
    <Card
      as="div"
      className={`income-source-card-box income-source-card-box--custom ${
        isActive ? "is-selected" : ""
      }`}
    >
      <Checkbox
        checked={!!isActive}
        onChange={() => changeSelectedSource(userId, sourceKey)}
        ariaLabel={title || _t("customIncomeTitle", "Income source title")}
      />
      <div className="income-source-card-box__fields">
        <TextField
          id={`custom-income-title-${sourceKey}`}
          size="sm"
          label={_t("customIncomeTitle", "Income source title")}
          placeholder={_t("customIncomeTitlePlaceholder", "e.g. Rental income")}
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          error={
            hasDuplicateTitle
              ? _t(
                  "duplicateIncomeTitle",
                  "An income source with this title already exists"
                )
              : false
          }
        />
        <TextField
          id={`custom-income-amount-${sourceKey}`}
          size="sm"
          type="number"
          min="0"
          label={_t("customIncomeAmount", "Monthly amount")}
          placeholder="0"
          value={amount}
          onChange={(e) => onAmountChange(e.target.value)}
          trailing={
            <span className="income-source-card-box__suffix">€/{_t("mo")}</span>
          }
        />
      </div>
      <Button
        variant="ghost"
        size="sm"
        iconOnly
        aria-label={_t("delete")}
        iconStart={<Icon name="close" size={16} />}
        onClick={onRemove}
      />
    </Card>
  );
};

export default CustomIncomeSourceCard;
